"use strict";
/**
 * @module React Input components
 * Wrapper over all input components
 */
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var text_input_component_1 = require("./text-input.component");
var select_component_1 = require("./select.component");
var input = function (props) {
    var inputElement = null;
    switch (props.elementType) {
        case ('input'):
            inputElement = React.createElement(text_input_component_1.default, { id: props.id, name: props.id, isDirty: props.isTouched, defaultValue: props.value, label: props.elementConfig.placeholder, errorMessage: props.elementConfig.suggestionText, onChange: props.changed, onBlur: props.changed, hasError: props.isInvalid && props.shouldValidate && props.isTouched });
            break;
        case ('select'):
            inputElement = (React.createElement(select_component_1.default, { id: props.id, name: props.id, value: props.value, hasError: props.isInvalid && props.shouldValidate && props.isTouched, label: props.elementConfig.placeholder, onChange: props.changed }, props.elementConfig.options.map(function (option) { return (React.createElement("option", { key: option.optionId, value: option.optionId }, option.optionValue)); })));
            break;
    }
    return inputElement;
};
exports.default = input;
